import PropTypes from "prop-types";
import React, { useContext, useState } from "react";

import API from "Signups/API.js";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks.js";
import { SignupsAppState } from "Signups/state.js";

import FnrListOption from "UI/FnrListOption";

SearchResultEntry.propTypes = {
  result: PropTypes.object.isRequired,
  defaultPhoto: PropTypes.string.isRequired,
  signupItemID: PropTypes.number.isRequired,
  closePopover: PropTypes.func.isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
};

export default function SearchResultEntry({
  result,
  defaultPhoto,
  signupItemID,
  closePopover,
  setSuccessMessage,
}) {
  const [state, dispatch] = useContext(SignupsAppState);
  const [isLoading, setIsLoading] = useState(false);
  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  const getDisplayName = () => {
    if (result.fname) {
      return `${result.fname || ""} ${result.lname || ""}`;
    } else if (result.email) {
      return result.email;
    } else {
      return "";
    }
  };

  const composeSuccessMessage = () => {
    if (result.fname) {
      return `${result.fname || ""} ${result.lname || ""} added!`;
    } else {
      return "Member added!";
    }
  };

  const handleClick = () => {
    const signupUserReq = API.signupOtherUserForItem({
      signupListID: state.currentSignupList.ID,
      signupItemID,
      userID: result.userID,
    });

    setIsLoading(true);

    signupUserReq
      .post()
      .then((responseData) => {
        console.log("responseData:", responseData);
        setIsLoading(false);
        dispatch({
          type: "Other User Signup Updated",
          signupList: responseData.signupList,
          allSignupLists: responseData.allSignupLists,
        });
        getSignupItem(signupItemID);
        closePopover();
        setSuccessMessage(composeSuccessMessage());
      })
      .catch((err) => {
        console.log("err:", err);
        setIsLoading(false);
        alert(
          "There was a problem adding the user to the signup. Please try again later."
        );
      });
  };

  return (
    <FnrListOption
      label={getDisplayName()}
      sublabel={result.isAlreadySignedUp ? "(Already signed up)" : null}
      disabled={result.isAlreadySignedUp}
      imageUrl={result.photoUrl}
      defaultImageUrl={defaultPhoto}
      onClick={handleClick}
      isLoading={isLoading}
    />
  );
}
